module.exports = __webpack_public_path__ + "img/pink.fdd6db17.svg";